import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import AuthFooter from '../components/shared/AuthFooter/AuthFooter'
import PasswordChange from '../components/PasswordChange/PasswordChange'
import WebLoading  from '../components/shared/WebLoading/WebLoading'

import { PASSWORD_CHANGE_ACTIONS } from '../store/actions/wallet'
import { containsNoErrors } from '../util/helpers'
import { RECEIVE_WALLET_NAV } from '../constants/navigation'
import requireWallet from '../hoc/requireWallet'
import requireUnlocked from '../hoc/requireUnlocked'
import { extractWalletFromHistory } from '../util/wallet'
import { getPasswordErrors } from '../util/errors'


const PASSWORD_ERRORS = {
  password: '',
  repeatPassword: ''
}

class PasswordChangeContainer extends Component {
  state = {
    errorMessages: PASSWORD_ERRORS
  }

  componentWillUnmount() {
    this.props.resetPasswordChangeState()
  }

  handleDoneClick = () => {
    const { history } = this.props
    history.push(RECEIVE_WALLET_NAV)
  }

  onPasswordChangeClick = () => {
    const { pwdChangeProfile } = this.props
    this.setState({
      errorMessages: getPasswordErrors(pwdChangeProfile)
    }, () => {
      if (containsNoErrors(this.state.errorMessages)) {
        this.props.onPasswordChangeAction(extractWalletFromHistory(this.props.history))
      }
    })
  }

  render() {
    const { loading, t } = this.props
    return (
      loading ? <WebLoading text={t(loading)} /> :
        <div className="main-container main-container--flex-column">
          <PasswordChange
            {...this.props}
            {...this.state}
            onPasswordChangeClick={this.onPasswordChangeClick}
            handleDoneClick={this.handleDoneClick}
          />
          <AuthFooter />
        </div>
    )
  }
}

const mapStateToProps = ({ walletReducer }) => {
  const { pwdChangeProfile } = walletReducer
  return {
    pwdChangeProfile: pwdChangeProfile
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    ...PASSWORD_CHANGE_ACTIONS
  }, dispatch)

export default requireWallet(requireUnlocked(connect(mapStateToProps, mapDispatchToProps)(PasswordChangeContainer)))



// WEBPACK FOOTER //
// ./src/containers/PasswordChangeContainer.js